// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.price-list-container {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  background: #f8fafc;
  min-height: 100vh;
}

.header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.header-nav {
  display: flex;
  gap: 1rem;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  text-decoration: none;
  color: #6b7280;
  font-weight: 500;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.nav-link:hover {
  color: #10b981;
  background: #f0fdf4;
  border-color: #10b981;
}

.nav-link.active {
  color: #10b981;
  background: #f0fdf4;
  border-color: #10b981;
}

.price-list-header {
  background: white;
  border-radius: 1rem;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.price-list-header h1 {
  color: #1f2937;
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.price-list-header p {
  color: #6b7280;
  margin: 0.5rem 0 0 0;
}

.add-item-btn {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s ease;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.add-item-btn:hover {
  background: linear-gradient(135deg, #059669, #047857);
  transform: translateY(-1px);
  box-shadow: 0 6px 8px -1px rgba(0, 0, 0, 0.15);
}

.add-item-form {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.add-item-form h3 {
  color: #1f2937;
  margin: 0 0 1rem 0;
  font-size: 1.25rem;
  font-weight: 600;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;
}

.form-row input,
.form-row select {
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  transition: border-color 0.2s ease;
}

.form-row input:focus,
.form-row select:focus {
  outline: none;
  border-color: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
}

.description-input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  margin-bottom: 1rem;
  transition: border-color 0.2s ease;
}

.description-input:focus {
  outline: none;
  border-color: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
}

.form-actions {
  display: flex;
  gap: 0.75rem;
}

.save-btn {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s ease;
}

.save-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #059669, #047857);
}

.save-btn:disabled {
  background: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}

.cancel-btn {
  background: #6b7280;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s ease;
}

.cancel-btn:hover:not(:disabled) {
  background: #4b5563;
}

.cancel-btn:disabled {
  background: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}

.add-item-btn:disabled {
  background: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}

.add-item-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #059669, #047857);
  transform: translateY(-1px);
  box-shadow: 0 6px 8px -1px rgba(0, 0, 0, 0.15);
}

.price-categories {
  display: grid;
  gap: 2rem;
}

.price-category {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
}

.price-category h2 {
  color: #1f2937;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 1.5rem 0;
  padding-bottom: 0.75rem;
  border-bottom: 3px solid #10b981;
  position: relative;
}

.price-category h2::after {
  content: '';
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, #10b981, #059669);
}

.price-items {
  display: grid;
  gap: 1rem;
}

.price-item {
  background: white;
  border: 1px solid #e5e7eb;
  border-left: 4px solid #10b981;
  border-radius: 0.75rem;
  padding: 1.5rem;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1);
}

.price-item:hover {
  border-left-color: #059669;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.item-info h3 {
  color: #1f2937;
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
}

.item-info .price {
  color: #10b981;
  font-size: 1.5rem;
  font-weight: 800;
  margin: 0 0 0.5rem 0;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.item-info .price::before {
  content: '₹';
  font-size: 1.25rem;
}

.item-info .description {
  color: #6b7280;
  font-size: 0.875rem;
  margin: 0;
  font-style: italic;
}

.item-actions {
  display: flex;
  gap: 0.5rem;
}

.edit-btn {
  background: #3b82f6;
  color: white;
  border: none;
  padding: 0.5rem;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.edit-btn:hover {
  background: #2563eb;
}

.delete-btn {
  background: #ef4444;
  color: white;
  border: none;
  padding: 0.5rem;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-btn:hover {
  background: #dc2626;
}

.edit-form {
  background: #f0fdf4;
  border: 2px solid #10b981;
  border-radius: 0.75rem;
  padding: 1.5rem;
  box-shadow: 0 4px 6px -1px rgba(16, 185, 129, 0.1);
}

.edit-form .form-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;
}

.edit-form input,
.edit-form select {
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  transition: border-color 0.2s ease;
  background: white;
}

.edit-form input:focus,
.edit-form select:focus {
  outline: none;
  border-color: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
}

.price-note {
  background: #fef3c7;
  border: 1px solid #f59e0b;
  border-radius: 0.5rem;
  padding: 1rem;
  margin-top: 2rem;
}

.price-note p {
  color: #92400e;
  margin: 0;
  font-size: 0.875rem;
}

.price-note strong {
  font-weight: 600;
}

/* Responsive Design */
@media (max-width: 768px) {
  .price-list-container {
    padding: 1rem;
  }
  
  .price-list-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
  
  .form-row {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
  
  .item-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
  
  .item-actions {
    align-self: flex-end;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/admin/PriceList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".price-list-container {\n  padding: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  background: #f8fafc;\n  min-height: 100vh;\n}\n\n.header-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.header-nav {\n  display: flex;\n  gap: 1rem;\n}\n\n.nav-link {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  border-radius: 0.5rem;\n  text-decoration: none;\n  color: #6b7280;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  border: 1px solid transparent;\n}\n\n.nav-link:hover {\n  color: #10b981;\n  background: #f0fdf4;\n  border-color: #10b981;\n}\n\n.nav-link.active {\n  color: #10b981;\n  background: #f0fdf4;\n  border-color: #10b981;\n}\n\n.price-list-header {\n  background: white;\n  border-radius: 1rem;\n  padding: 2rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.price-list-header h1 {\n  color: #1f2937;\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0;\n}\n\n.price-list-header p {\n  color: #6b7280;\n  margin: 0.5rem 0 0 0;\n}\n\n.add-item-btn {\n  background: linear-gradient(135deg, #10b981, #059669);\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 0.5rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.add-item-btn:hover {\n  background: linear-gradient(135deg, #059669, #047857);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 8px -1px rgba(0, 0, 0, 0.15);\n}\n\n.add-item-form {\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.75rem;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.add-item-form h3 {\n  color: #1f2937;\n  margin: 0 0 1rem 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 2fr 1fr 1fr;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.form-row input,\n.form-row select {\n  padding: 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  transition: border-color 0.2s ease;\n}\n\n.form-row input:focus,\n.form-row select:focus {\n  outline: none;\n  border-color: #10b981;\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);\n}\n\n.description-input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  margin-bottom: 1rem;\n  transition: border-color 0.2s ease;\n}\n\n.description-input:focus {\n  outline: none;\n  border-color: #10b981;\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);\n}\n\n.form-actions {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.save-btn {\n  background: linear-gradient(135deg, #10b981, #059669);\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 0.5rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  transition: all 0.2s ease;\n}\n\n.save-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #059669, #047857);\n}\n\n.save-btn:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.cancel-btn {\n  background: #6b7280;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 0.5rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  transition: all 0.2s ease;\n}\n\n.cancel-btn:hover:not(:disabled) {\n  background: #4b5563;\n}\n\n.cancel-btn:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.add-item-btn:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.add-item-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #059669, #047857);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 8px -1px rgba(0, 0, 0, 0.15);\n}\n\n.price-categories {\n  display: grid;\n  gap: 2rem;\n}\n\n.price-category {\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 1rem;\n  padding: 2rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  margin-bottom: 2rem;\n}\n\n.price-category h2 {\n  color: #1f2937;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0 0 1.5rem 0;\n  padding-bottom: 0.75rem;\n  border-bottom: 3px solid #10b981;\n  position: relative;\n}\n\n.price-category h2::after {\n  content: '';\n  position: absolute;\n  bottom: -3px;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  background: linear-gradient(90deg, #10b981, #059669);\n}\n\n.price-items {\n  display: grid;\n  gap: 1rem;\n}\n\n.price-item {\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-left: 4px solid #10b981;\n  border-radius: 0.75rem;\n  padding: 1.5rem;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1);\n}\n\n.price-item:hover {\n  border-left-color: #059669;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  transform: translateY(-1px);\n}\n\n.item-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.item-info h3 {\n  color: #1f2937;\n  font-size: 1.25rem;\n  font-weight: 700;\n  margin: 0 0 0.5rem 0;\n}\n\n.item-info .price {\n  color: #10b981;\n  font-size: 1.5rem;\n  font-weight: 800;\n  margin: 0 0 0.5rem 0;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.item-info .price::before {\n  content: '₹';\n  font-size: 1.25rem;\n}\n\n.item-info .description {\n  color: #6b7280;\n  font-size: 0.875rem;\n  margin: 0;\n  font-style: italic;\n}\n\n.item-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.edit-btn {\n  background: #3b82f6;\n  color: white;\n  border: none;\n  padding: 0.5rem;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.edit-btn:hover {\n  background: #2563eb;\n}\n\n.delete-btn {\n  background: #ef4444;\n  color: white;\n  border: none;\n  padding: 0.5rem;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.delete-btn:hover {\n  background: #dc2626;\n}\n\n.edit-form {\n  background: #f0fdf4;\n  border: 2px solid #10b981;\n  border-radius: 0.75rem;\n  padding: 1.5rem;\n  box-shadow: 0 4px 6px -1px rgba(16, 185, 129, 0.1);\n}\n\n.edit-form .form-row {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.edit-form input,\n.edit-form select {\n  padding: 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  transition: border-color 0.2s ease;\n  background: white;\n}\n\n.edit-form input:focus,\n.edit-form select:focus {\n  outline: none;\n  border-color: #10b981;\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);\n}\n\n.price-note {\n  background: #fef3c7;\n  border: 1px solid #f59e0b;\n  border-radius: 0.5rem;\n  padding: 1rem;\n  margin-top: 2rem;\n}\n\n.price-note p {\n  color: #92400e;\n  margin: 0;\n  font-size: 0.875rem;\n}\n\n.price-note strong {\n  font-weight: 600;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .price-list-container {\n    padding: 1rem;\n  }\n  \n  .price-list-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n  \n  .form-row {\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n  }\n  \n  .item-content {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n  \n  .item-actions {\n    align-self: flex-end;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
